<template>
    <section id="contactus" class="gradient" style="min-height: 700px; color:#FFFFFF">
        <mdb-container>
            <mdb-row class="py-5">
                <mdb-col md="6">
                    <h6 class="section-header-top">Contact Us</h6>
                    <h2>HOW CAN WE HELP</h2>
                    <hr class="hr-light"/>
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <mdb-col md="6">
                    <mdb-card style="min-height: 460px; max-height: 460px">
                        <!--                        <mdb-card-image style="max-height: 400px; max-width: 400px" :src="require('@/assets/fullerlabs.jpg')" alt="Card image cap"></mdb-card-image>-->
                        <mdb-card-body>
                            <mdb-card-title class="text-dark text-uppercase font-weight-light"
                            style="font-size: 2em; letter-spacing: 0.02em">Worcester Polytechnic
                                Institute<br/> <span class="mt-5 pt-5">Data Science</span>
                            </mdb-card-title>
                            <div style="position: absolute; bottom: 20px">
                            <mdb-card-text class="" style="font-size: 1.2em;">
                                <p><mdb-icon class="pr-3 pt-2" icon="location-arrow" style="font-size: 30px"/> 242, Fuller Laboratories</p>
                                <p><mdb-icon class="pr-3" icon="phone-alt" style="font-size: 30px" /> 508-831-4883</p>
                                <p><mdb-icon class="pr-3"  icon="fax" style="font-size: 30px"/> 508-831-5776</p>
                                <p><mdb-icon class="pr-3"  icon="envelope" style="font-size: 30px"/> gr-wpi-arl-dsrg@wpi.edu</p>
                            </mdb-card-text>
                            <a class="btn btn-primary ripple-parent" href="mailto:gr-wpi-arl-dsrg@wpi.edu">Email</a>
                            </div>
                        </mdb-card-body>
                    </mdb-card>
                </mdb-col>
                <mdb-col md="6" class="d-none d-sm-none d-md-block">
                    <img src="../assets/fullerlabs-min.jpg" style="max-height: 460px"
                         class="rounded img-fluid z-depth-2 img" alt="1">
                </mdb-col>
            </mdb-row>
        </mdb-container>
    </section>
</template>

<script>
    import {mdbContainer, mdbRow, mdbCol, mdbIcon} from 'mdbvue';
    import {mdbCard, mdbCardImage, mdbCardBody, mdbCardTitle, mdbCardText, mdbBtn} from 'mdbvue';

    export default {
        name: "ContactUs",
        components: {
            mdbContainer,
            mdbRow,
            mdbCol,
            mdbCard,
            // mdbCardImage,
            mdbCardBody,
            mdbCardTitle,
            mdbCardText,
            // mdbBtn,
            mdbIcon
        }
    }


</script>

<style scoped>


</style>